import { AutogenModelHubtranInterfaceCodes, AutogenRowHubtranInterfaceCodes } from "./autogen/AutogenModelHubtranInterfaceCodes";

export class ModelHubtranInterfaceCodes extends AutogenModelHubtranInterfaceCodes<RowHubtranInterfaceCodes> {
	constructor() {
		super(RowHubtranInterfaceCodes);
	}
}

export class RowHubtranInterfaceCodes extends AutogenRowHubtranInterfaceCodes {
}